import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useState } from "react";
import { BentoBrand } from "schemas/dashboard";

import BrandMetadata from "features/Influencer/Discover/DetailedBrandView/components/BrandMetadata";
import { BrandCardSource } from "features/Influencer/Discover/Results/schema";
import BrandSocialLinks from "features/Influencer/Discover/Shared/BrandSocialLinks";
import { generateInitials } from "utils/string";

const styles = {
  badge: {
    my: 2,
    background: "white",
    p: 3,
    border: `1px solid #DFDFDF`,
    borderRadius: "20px",
  },
  roundImage: {
    objectFit: "contain",
    width: 75,
    height: 75,
    borderRadius: 40,
    border: "1px solid",
    borderColor: grey[200],
  },
  avatar: {
    backgroundColor: "green.dark",
    width: 75,
    height: 75,
    fontSize: "28px",
  },
  brandName: {
    fontSize: "20px",
    fontWeight: 600,
  },
  divider: { my: 2, borderColor: "#DFDFDF" },
  matchText: { width: "100%", fontSize: "16px" },
};

export default function PitchBrand({ bentoBrand }: { bentoBrand: BentoBrand }) {
  const [imgError, setImgError] = useState<boolean>(false);

  return (
    <Grid item xs={12} justifyContent="center" container sx={styles.badge}>
      <Grid item xs={12} gap={1} container alignItems="center">
        <Grid item xs="auto">
          {bentoBrand?.logoUrl && !imgError ? (
            <Box
              sx={styles.roundImage}
              component="img"
              src={bentoBrand?.logoUrl}
              onError={() => setImgError(true)}
            />
          ) : (
            <Avatar sx={styles.avatar}>
              {generateInitials(bentoBrand?.brandName)}
            </Avatar>
          )}
        </Grid>
        <Grid item xs container gap={1}>
          <Grid item xs={12}>
            <Typography sx={styles.brandName}>
              {bentoBrand.normalizedName}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Box display="flex" flexDirection="row" flexWrap="wrap" gap={0.5}>
              <BrandMetadata
                selectedBrand={bentoBrand}
                noGrid
                clickable={false}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <BrandSocialLinks
              instagramFollowerCount={bentoBrand.instagramFollowerCount}
              instagramUsername={bentoBrand.instagramUsername}
              bentoBrandId={bentoBrand.id}
              website={bentoBrand.website}
              source={BrandCardSource.SIMILAR_BRANDS}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider sx={styles.divider} />
      </Grid>

      <Grid item xs={12} container>
        <Typography sx={styles.matchText}>
          <em>Good match for your engagement & niche</em>
        </Typography>
      </Grid>
    </Grid>
  );
}
